import {
  ICheckboxStyleProps,
  ICheckboxStyles
} from '@fluentui/react/lib/Checkbox';
import { ITheme } from '@fluentui/react/lib/Styling';
import { teamsBorderRadius } from './constants';

export function getCheckboxStyles(themeName: string, _theme: ITheme) {
  return (props: ICheckboxStyleProps): Partial<ICheckboxStyles> => {
    const { disabled, checked, theme } = props;
    const { palette } = theme;

    let CHECKBOX_BORDER_COLOR = palette.neutralTertiary;
    let CHECKBOX_LABEL_COLOR = palette.neutralTertiary;

    if (themeName === 'contrast') {
      CHECKBOX_BORDER_COLOR = 'green';
      CHECKBOX_LABEL_COLOR = 'green';
    }

    const styles = {
      input: {
        selectors: {
          '.ms-Fabric--isFocusVisible &': {
            selectors: {
              ':focus + label': {
                selectors: {
                  '::before': {
                    top: '-2px',
                    left: '-4px',
                    bottom: '-3px',
                    right: '-5px',
                    outline: 'none',
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: palette.black,
                    borderRadius: teamsBorderRadius
                  }
                }
              }
            }
          }
        }
      },
      checkbox: [
        {
          borderRadius: 4,
          height: 17,
          width: 17
        },
        !disabled &&
          !checked && {
            borderColor: palette.black
          },
        disabled && {
          borderColor: CHECKBOX_BORDER_COLOR
        },
        checked &&
          disabled && {
            background: CHECKBOX_BORDER_COLOR,
            borderColor: CHECKBOX_BORDER_COLOR
          },
        !disabled &&
          checked && {
            background: palette.themePrimary
          }
      ],
      checkmark: [
        {
          fontWeight: 'bold',
          fontSize: 12,
          border: 'none',
          background: 'none',
          color: palette.white
        }
      ],
      root: [
        {
          color: palette.neutralDark,
          selectors: {
            a: {
              color: 'inherit',
              selectors: {
                ':link': {
                  color: 'inherit'
                },
                ':visited': {
                  color: 'inherit'
                },
                ':hover': {
                  color: 'inherit'
                }
              }
            }
          }
        },
        !disabled &&
          checked && {
            color: palette.black,
            selectors: {
              ':hover': {
                color: palette.black,
                selectors: {
                  '.ms-Checkbox-checkbox': {
                    background: palette.themePrimary,
                    borderColor: palette.themePrimary
                  },
                  '.ms-Checkbox-text': {
                    color: palette.black
                  }
                }
              }
            }
          },
        !disabled &&
          !checked && {
            color: palette.neutralDark,
            selectors: {
              ':hover': {
                selectors: {
                  '.ms-Checkbox-text': {
                    color: palette.neutralDark
                  },
                  '.ms-Checkbox-checkbox': {
                    border: `1px solid ${palette.black}`
                  },
                  '.ms-Checkbox-checkmark': {
                    color: palette.neutralSecondary
                  }
                }
              }
            }
          }
      ],
      label: [
        {
          alignItems: 'center'
        }
      ],
      text: [
        disabled && {
          color: CHECKBOX_LABEL_COLOR
        },
        !disabled &&
          checked && {
            color: palette.black
          },

        !disabled &&
          !checked && {
            color: palette.neutralDark
          }
      ]
    } as Partial<ICheckboxStyles>;

    // Contrast theme overrides
    return styles;
  };
}
